<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartData: this.data,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {

        },
        ...this.options
      },
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions, {plugins: this.plugins})
  }
}
</script>

<style>
#chartjs-tooltip {
  z-index: 99999;
  background: transparent;
}

.tooltip-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #F2F4F7;
  font: 14px Lato, sans-serif;
  overflow: hidden;
  min-width: 320px;
}

.tooltip-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background: #f5f5f7;
  }

.tooltip-title {
  font-size: 16px;
  color: #182230;
}

.tooltip-subtitle {
  font-size: 14px;
  font-weight: 800;
  color: #182230;
}

.tooltip-content {
  padding: 0;
}

.tooltip-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 8px 16px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
}

.tooltip-row:last-child {
  border-bottom: none;
}

.tooltip-label {
  font-size: 14px;
  color: #182230;
}

.tooltip-value {
  font-size: 14px;
  font-weight: 800;
  color: #182230;
  margin-right: 24px;
  text-align: right;
}

.tooltip-indicator {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 4px;
}

.tooltip-total {
  font-weight: 600;
}

.tooltip-total .tooltip-label,
.tooltip-total .tooltip-value {
  font-weight: 600;
}
</style>